module.exports = __webpack_public_path__ + "static/media/Login.55e3c6c5.png";